const healthRecordRouter = [
    {
        path:'index/:id',
        name:'healthRecord-index',
        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/index.vue'),
    },
    {
        path:'list',
        name:'healthRecord-list',
        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/list.vue'),
        children:[
            {
                path:'inHospitalList',
                name:'healthRecord-inHospitalList',
                component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/inHospitalListList.vue')
            },{
                path:'closedCasesList',
                name:'healthRecord-closedCasesList',
                component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/closedCasesList.vue')
            },
        ],
    },{
        path:'create/:id',
        name:'healthRecord-create',
        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/create.vue'),
    },{
        path:'detail/:id',
        name:'healthRecord-detail',
        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/detail.vue'),
        redirect: { name: 'healthRecord-initExamine' },
        children:[
            {
                path:'acceptance', //受理紀錄
                name:'healthRecord-acceptance',
                component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/acceptance/index.vue')
            },
            {
                path:'initExamine', //初步檢傷
                name:'healthRecord-initExamine',
                redirect: { name: 'initExamine-list' },
                children:[
                    {
                        path:'create/:uid',
                        name:'initExamine-create',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/initExamine/create.vue')
                    },
                    {
                        path:'list',
                        name:'initExamine-list',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/initExamine/list.vue')
                    },
                    {
                        path:'detail/:uid',
                        name:'initExamine-detail',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/initExamine/detail.vue')
                    },
                    {
                        path:'edit/:uid',
                        name:'initExamine-edit',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/initExamine/edit.vue')
                    },
                ]
            },{
                path:'diagnosis', //診療紀錄
                name:'healthRecord-diagnosis',
                redirect: { name: 'diagnosis-list' },
                children:[
                    {
                        path:'list',
                        name:'diagnosis-list',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/diagnosis/list.vue')
                    },
                    {
                        path:'create',
                        name:'diagnosis-create',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/diagnosis/create.vue')
                    },
                    {
                        path:'edit/:uid',
                        name:'diagnosis-edit',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/diagnosis/edit.vue')
                    },
                    {
                        path:'detail/:uid',
                        name:'diagnosis-detail',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/diagnosis/detail.vue')
                    },
                ]
            },{
                path:'takeCare', //照養紀錄
                name:'healthRecord-takeCare',
                redirect: { name: 'takeCare-list' },
                children:[
                    {
                        path:'list',
                        name:'takeCare-list',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/takeCare/list.vue')
                    },{
                        path:'detail/:uid',
                        name:'takeCare-detail',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/takeCare/detail.vue')
                    },{
                        path:'edit/:uid',
                        name:'takeCare-edit',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/takeCare/edit.vue')
                    },
                ]
            },{
                path:'recipe', //照養紀錄>食譜管理
                name:'healthRecord-recipe',
                redirect: { name: 'recipe-index' },
                children:[
                    {
                        path:'index',
                        name:'recipe-index',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/recipe/index.vue')
                    },{
                        path:'edit',
                        name:'recipe-edit',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/recipe/edit.vue')
                    },
                ]
            },{
                path:'medicine', //開藥紀錄
                name:'healthRecord-medicine',
                redirect: { name: 'medicine-list' },
                children:[
                    {
                        path:'list',
                        name:'medicine-list',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/medicine/list.vue')
                    },{
                        path:'create',
                        name:'medicine-create',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/medicine/create.vue')
                    },{
                        path:'detail/:uid',
                        name:'medicine-detail',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/medicine/detail.vue')
                    },{
                        path:'edit/:uid',
                        name:'medicine-edit',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/medicine/edit.vue')
                    },{
                        path:'apply/:uid',
                        name:'medicine-apply',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/medicine/create.vue')
                    },
                ]
            },{
                path:'anesthesia', //麻醉紀錄
                name:'healthRecord-anesthesia',
                redirect: { name: 'anesthesia-list' },
                children:[
                    {
                        path:'list',
                        name:'anesthesia-list',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/anesthesia/list.vue')
                    },{
                        path:'create',
                        name:'anesthesia-create',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/anesthesia/create.vue')
                    },{
                        path:'edit/:uid',
                        name:'anesthesia-edit',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/anesthesia/edit.vue')
                    },{
                        path:'detail/:uid',
                        name:'anesthesia-detail',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/anesthesia/detail.vue')
                    },
                ]
            },{
                path:'test',
                name:'healthRecord-test',
                redirect: { name: 'test-list' },
                children:[
                    {
                        path:'list',
                        name:'test-list',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/test/list.vue')
                    },{
                        path:'detail/:uid/:type',
                        name:'test-detail',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/test/detail.vue')
                    },{
                        path:'edit/:uid/:type',
                        name:'test-edit',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/test/edit.vue')
                    }
                ]
            },{
                path:'surgery', //手術紀錄
                name:'healthRecord-surgery',
                redirect: { name: 'surgery-list' },
                children:[
                    {
                        path:'list',
                        name:'surgery-list',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/surgery/list.vue')
                    },{
                        path:'create',
                        name:'surgery-create',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/surgery/create.vue')
                    },{
                        path:'edit/:uid',
                        name:'surgery-edit',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/surgery/edit.vue')
                    },{
                        path:'detail/:uid',
                        name:'surgery-detail',
                        component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/surgery/detail.vue')
                    },
                ]
                // component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/surgery.vue')
            },{
                path:'dissect',
                name:'healthRecord-dissect',
                component: () => import(/* webpackChunkName: "about" */ '../views/healthRecord/tabs/dissect/index.vue')
            },
        ]
    },
    
  ]
  export default healthRecordRouter